(function ($) {
  // accordion on people page
  $('.js-accordion-toggle').on('click', function () {
    var $wrapper = $(this).closest('.js-accordion');
    var multipleExpandedEnabled = $wrapper.data('accordion-multiple-expanded');
    var $content = $wrapper.find('.js-accordion-content');
    var $title = $wrapper.find(
      '.js-accordion-title',
    ); /* need to change class too because of plus sign behaviour */

    if (!$wrapper.hasClass('is-expanded')) {
      if (!multipleExpandedEnabled) {
        // close all other expanded accordions
        $('.js-accordion').removeClass('is-expanded');
        $('.js-accordion-title').removeClass('is-expanded');
        $('.js-accordion-content').slideUp();
      }

      // open only current one
      $wrapper.addClass('is-expanded');
      $title.addClass('is-expanded');
      $content.slideDown(400, function () {
        // Scroll to opened accordion, so we don't loose focus when larger accordion is closed
        $('html, body').animate(
          {
            scrollTop: $content.offset().top - 200, // approx. header + accordion btn heights
          },
          400,
        );
      });
    } else {
      // remove classes after slideup animation is finished
      $content.slideUp(400, function () {
        $wrapper.removeClass('is-expanded');
        $title.removeClass('is-expanded');
      });
    }
  });
})(jQuery);
